import { Menu } from "@mantine/core";
import { useNavigate } from "react-router";

export function CreateNewInvoiceMenuItem() {
  const navigate = useNavigate();

  function handleClick() {
    navigate("/invoices/add-new");
  }

  return <Menu.Item onClick={handleClick}>Create New Invoice</Menu.Item>;
}
